import React from "react";
import axios from "axios";
import moment from "moment";
import { store } from '../../redux/store';
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import tokenErrorHandler from "../tokenErrorHandler";
import BillListTotalComponent from "./BillListTotalComponent";
import BillListHistory from './BillListHistory';
import { Link } from "react-router-dom";
import './billList.css';
import { selectedConsumerList, setBillListConsumers, setBillListEndIndex, setBillListKeys, setBillListStartIndex, setBillListTotalAmount, setBillLsitsStartIndex, setTotalDueList, totalActiveConsumers, totalConsumerNo, totalInActiveConsumers, totalInActives } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class BillList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			consumerList: [],
			message: '',
			totalAmount: 0,
			loading: false

		}
	}



	componentDidMount() {
		console.log('loading.........')
		this.setState({
			loading: true
		})
		store.dispatch(setBillListEndIndex(''));
		store.dispatch(setBillListStartIndex(''));
		store.dispatch(selectedConsumerList([]));
		store.dispatch(setTotalDueList([]))
		store.dispatch(setBillListConsumers([]));
		store.dispatch(setBillListKeys([]));
		store.dispatch(setBillListTotalAmount(0));
		var totalActives = 0;
		var totalInactives = 0;

		var url = '/api/v1/billpay/corp/consumer/get-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		var value = (this.props.startDate != '' &&
			this.props.startDate != undefined &&
			this.props.startDate != null) ?
			'/' + this.props.startDate
			: '/all';

		var value1 = (this.props.endDate != '' &&
			this.props.endDate != undefined &&
			this.props.endDate != null) ?
			'/' + this.props.endDate
			: '/all'

		httpClient.get(url + this.props.agentInfo +
			value + value1,
			{ headers }
		).then((response) => {

			var bills = [];
			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.reverse().map(res => {
					if (res.fetchRequired == false) {
						if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							res.lastKnownStatus != 'BILL_PAY_PENDING' &&
							res.lastKnownStatus != 'BILL_PAY_PROCESSING') {
							if (!bills.includes(res)) {
								bills.push(res);
								store.dispatch(setBillListConsumers(bills))
							}

						}
					} else {
						if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							res.lastKnownStatus != 'BILL_PAY_PENDING' &&
							res.lastKnownStatus != 'BILL_PAY_PROCESSING' &&
							res.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
							res.currentBillPayAmount != undefined &&
							res.currentBillPayAmount != null &&
							res.currentBillPayAmount > 0
						) {
							if (!bills.includes(res)) {
								bills.push(res);
								setTimeout(() => {
									store.dispatch(setBillListConsumers(bills))	
								}, 300);
								
							}
						}
					}
					// if ((res.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
					// 	res.fetchRequired == true) &&
					// 	res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
					// 	res.lastKnownStatus != 'BILL_PAY_PENDING' &&
					// 	res.lastKnownStatus != 'BILL_PAY_PROCESSING') {
					// 	bills.push(res);
					// }

				})
			}

			setTimeout(() => {
				
				this.setState({
					consumerList: bills
				})
			}, 400);


			this.setState({
				loading: false
			})
			var list = [];
			var totalAmount = 0;
			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.reverse().map(res => {
					if (res.fetchRequired == false) {
						if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							res.lastKnownStatus != 'BILL_PAY_PENDING' &&
							res.lastKnownStatus != 'BILL_PAY_PROCESSING') {
							if (res.optional != null) {
								const map = new Map(Object.entries(res.optional));
								var mapKeys = [...map.keys()];
								mapKeys.map(key => {

									var optionMap = {
										key: key,
										value: map.get(key),
										id: res.id
									}

									list.push(optionMap)
									store.dispatch(setBillListKeys(list))
								})

							}

							if (res.active == true) {
								totalActives = totalActives + 1;
							} else {
								totalInactives = totalInactives + 1;
							}
							if (res.currentBillPayAmount != undefined &&
								res.currentBillPayAmount != null &&
								res.currentBillPayAmount > 0
							) {
								totalAmount = totalAmount + res.currentBillPayAmount;
								setTimeout(() => {
									store.dispatch(setBillListTotalAmount(totalAmount))
								}, 300);
								

							}
							

						}
					} else {
						if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							res.lastKnownStatus != 'BILL_PAY_PENDING' &&
							res.lastKnownStatus != 'BILL_PAY_PROCESSING' &&
							res.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
							res.currentBillPayAmount != undefined &&
							res.currentBillPayAmount != null &&
							res.currentBillPayAmount > 0) {
							if (res.optional != null) {
								const map = new Map(Object.entries(res.optional));
								var mapKeys = [...map.keys()];
								mapKeys.map(key => {

									var optionMap = {
										key: key,
										value: map.get(key),
										id: res.id
									}

									list.push(optionMap)
									store.dispatch(setBillListKeys(list))
								})

							}

							if (res.active == true) {
								totalActives = totalActives + 1;
							} else {
								totalInactives = totalInactives + 1;
							}
							if (res.currentBillPayAmount != undefined &&
								res.currentBillPayAmount > 0
							) {
								totalAmount = totalAmount + res.currentBillPayAmount;
								console.log('totalAmount...'+totalAmount);
								setTimeout(() => {
									store.dispatch(setBillListTotalAmount(totalAmount))
								}, 300);
								
							}
							
						}
					}
				})
			}

			setTimeout(() => {
				
				this.setState({
					totalAmount: totalAmount
				})
				
				this.setState({
					keys: list
				})
			}, 200);




			var dwnLoadDtaList = [];

			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.reverse().map(consumer => {
					if (consumer.fetchRequired == false) {
						if (consumer.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							consumer.lastKnownStatus != 'BILL_PAY_PENDING' &&
							consumer.lastKnownStatus != 'BILL_PAY_PROCESSING') {
							var optional1 = '';
							var operator_id = '';

							if (consumer.lastPaidBill != undefined &&
								consumer.lastPaidBill != null) {
								optional1 = consumer.lastPaidBill.optional;
								if (optional1 != undefined &&
									optional1 != null) {
									operator_id = optional1.OPERATOR_ID;
									if (operator_id == undefined ||
										operator_id == null ||
										operator_id == '') {
										operator_id = optional1.operator_id;
									}
								}
							}
							var data = {
								ID: consumer.id,
								RequesterId: consumer.requesterId,
								AgentId: consumer.agentId,
								OrderId: consumer.orderId,
								Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
								Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
								CreateOrderDate: consumer.createOrderDate,
								ConsumerName: consumer.consumerName,
								Branch: consumer.branchNameOrId,
								BillerCategory: consumer.billerCategory,
								BillerName: consumer.billerName,
								DueDate: consumer.dueDate,
								LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
								Operator: consumer.operator,
								MobileNo: consumer.mobileNo,
								Last_Status: consumer.lastKnownStatus,
								BatchId: consumer.batchId,
								TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
								Amount: consumer.currentBillPayAmount,

							}
							if(!dwnLoadDtaList.includes(data)){
								dwnLoadDtaList.push(data);
								setTimeout(() => {
									store.dispatch(setTotalDueList(dwnLoadDtaList))
								}, 300);
								
							}
							
						}
					} else {
						if (consumer.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
							consumer.lastKnownStatus != 'BILL_PAY_PENDING' &&
							consumer.lastKnownStatus != 'BILL_PAY_PROCESSING' &&
							consumer.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
							consumer.currentBillPayAmount != undefined &&
							consumer.currentBillPayAmount != null &&
							consumer.currentBillPayAmount > 0) {
							var optional1 = '';
							var operator_id = '';

							if (consumer.lastPaidBill != undefined &&
								consumer.lastPaidBill != null) {
								optional1 = consumer.lastPaidBill.optional;
								if (optional1 != undefined &&
									optional1 != null) {
									operator_id = optional1.OPERATOR_ID;
									if (operator_id == undefined ||
										operator_id == null ||
										operator_id == '') {
										operator_id = optional1.operator_id;
									}
								}
							}
							var data = {
								ID: consumer.id,
								RequesterId: consumer.requesterId,
								AgentId: consumer.agentId,
								OrderId: consumer.orderId,
								Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
								Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
								CreateOrderDate: consumer.createOrderDate,
								ConsumerName: consumer.consumerName,
								Branch: consumer.branchNameOrId,
								BillerCategory: consumer.billerCategory,
								BillerName: consumer.billerName,
								DueDate: consumer.dueDate,
								LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
								Operator: consumer.operator,
								MobileNo: consumer.mobileNo,
								Last_Status: consumer.lastKnownStatus,
								BatchId: consumer.batchId,
								TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
								Amount: consumer.currentBillPayAmount,

							}
							if(!dwnLoadDtaList.includes(data)){
								dwnLoadDtaList.push(data);
								setTimeout(() => {
									store.dispatch(setTotalDueList(dwnLoadDtaList))	
								}, 300);
								
							}
						}
					}

				});
			}

		


		}).catch(error => {

			this.setState({
				loading: false
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		});
	}
	componentWillUnmount() {
	}


	render() {
		console.log('Inside render');
		var headerTitle = "Bill List";
		return (

			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">

										{/* <CommonTitleHeader headerTitle={headerTitle} /> */}
										<BillListTotalComponent />
										{this.state.loading == true &&

											<div class>Loading....
												<div class="spinner-grow spinner-grow-sm"></div>
											</div>
										}
										{this.state.loading == false &&
											this.props.billListConsumers != undefined &&
											this.props.billListConsumers.length > 0 &&
											<BillListHistory consumerList={this.state.consumerList} options={this.state.keys} />
										}
										{this.state.loading == false &&
											this.props.billListConsumers != undefined &&
											this.props.billListConsumers.length == 0 &&
											<div>No Bill Found.</div>
										}

									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, token, agentInfo, clientRole, deviceInfo,
			selecetDueDate, startDate, endDate, billListConsumers } }
) => ({
	errorMessage, phone, token, agentInfo, clientRole, deviceInfo,
	selecetDueDate, startDate, endDate, billListConsumers
});

export default connect(mapStateToProps, null)(BillList);
